const pre = 'feature-';

export default [
  {
      path: '/foo',
      name: `${pre}foo`,
      meta: {
          title: '项目内容'
      },
      component: () =>
          import ('@/views/feature/foo')
  },
  {
      path: '/paper',
      name: `${pre}paper`,
      meta: {
          title: '答卷'
      },
      component: () =>
          import ('@/views/feature/paper/index')
  },
  {
      path: '/reviewRecord',
      name: `${pre}reviewRecord`,
      meta: {
          title: '待审核记录'
      },
      component: () =>
          import ('@/views/feature/reviewRecord/index')
  },
  {
      path: '/record',
      name: `${pre}record`,
      meta: {
          title: '历史审核记录'
      },
      component: () =>
          import ('@/views/feature/reviewRecord/record')
  },
  {
      path: '/map',
      name: `${pre}map`,
      meta: {
          title: '导航'
      },
      component: () =>
          import ('@/views/feature/map/index')
  },


]
